import { render, staticRenderFns } from "./mostSuspiciousProductPieChart.vue?vue&type=template&id=7142ba55&scoped=true&"
import script from "./mostSuspiciousProductPieChart.vue?vue&type=script&lang=js&"
export * from "./mostSuspiciousProductPieChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7142ba55",
  null
  
)

export default component.exports